import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useForm } from '@inertiajs/vue3';
    import DialogForm from '@/components/DialogForm.vue';
    import { Payroll, Employee } from '@/types';
    import QueryKey from '@/enums/QueryKey';
    import RemoveEmployeeFromPayrollForm from '@/components/salary/RemoveEmployeeFromPayrollForm.vue';
    import RemoveButton from '@/components/RemoveButton.vue';
    import { usePage } from '@inertiajs/vue3';
    import type { SharedData } from '@/types';
    import { computed } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'RemoveEmployeeFromPayroll',
  props: {
    payroll: {},
    disabled: { type: Boolean },
    employees: {}
  },
  setup(__props: any) {

    const props = __props;

    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    const form = useForm({
        employee_id: null,
        terminate: 0,
        termination_date: null,
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DialogForm, {
    type: "create",
    form: _unref(form),
    route: 
            _ctx.route('v2.salary.payrolls.remove-employee', {
                payroll: props.payroll.id,
                employeeId: _unref(form).employee_id,
            })
        ,
    method: "delete",
    "query-key": [_unref(QueryKey).PAYROLL, selectedCompanyId.value, props.payroll.id],
    title: "payrolls.remove_employee_from_payroll.header",
    "submit-text": "payrolls.remove_employee_from_payroll.remove_employee",
    "submit-variant": "destructive"
  }, {
    trigger: _withCtx(() => [
      _createVNode(RemoveButton, {
        "button-text": "payrolls.other_buttons.remove_employee_from_payroll",
        disabled: props.disabled
      }, null, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _createVNode(RemoveEmployeeFromPayrollForm, {
        form: _unref(form),
        payroll: props.payroll,
        employees: props.employees
      }, null, 8, ["form", "payroll", "employees"])
    ]),
    _: 1
  }, 8, ["form", "route", "query-key"]))
}
}

})